module.exports = __webpack_public_path__ + "images/花筑奢pr长图_08-5.jpg?v=f40d2ac5";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_08-5.jpg
 ** module id = 48
 ** module chunks = 1 2
 **/